export function resizeImage(file: File, size: number): Promise<File> {
  return new Promise((resolve, reject) => {
    const fileName = file.name
    const reader = new FileReader()

    reader.readAsDataURL(file)

    reader.onload = (event) => {
      const img = new Image()
      if (event?.target?.result) {
        img.src = event.target.result.toString()
      } else {
        reject('Error reading file data')
      }

      img.onload = () => {
        const elem = document.createElement('canvas')
        let transformedWidth = 0
        let transformedHeight = 0

        if (img.width > img.height) {
          const scaleFactor = size / img.width
          elem.width = size
          elem.height = img.height * scaleFactor
          transformedWidth = size
          transformedHeight = img.height * scaleFactor
        } else {
          const scaleFactor = size / img.height
          elem.height = size
          elem.width = img.width * scaleFactor
          transformedWidth = img.width * scaleFactor
          transformedHeight = size
        }

        const ctx = elem.getContext('2d')
        if (ctx) {
          ctx.drawImage(img, 0, 0, transformedWidth, transformedHeight)
          ctx.canvas.toBlob(
            (blob) => {
              if (blob) {
                resolve(
                  new File([blob], fileName, {
                    type: file.type,
                    lastModified: Date.now(),
                  })
                )
              }
            },
            file.type,
            1
          )
        } else {
          reject('Error creating CTX context')
        }
      }
    }
  })
}

// Appends '.thumb' to the end of the filename
export const appendThumbToFileName = (originalFileName: string) => {
  const indexOfFileExtension =
    originalFileName.lastIndexOf('.') || originalFileName.length
  const fileName = originalFileName.slice(0, indexOfFileExtension)
  const fileNameLength = originalFileName.length
  const fileExtension = originalFileName.slice(
    indexOfFileExtension,
    fileNameLength
  )
  const thumbnailFileName = fileName.concat('.thumb', fileExtension)

  return thumbnailFileName
}

interface UploadJobImageParams {
  jobId: string
  imageFile: File
  fileSetId: string
  isThumbnail: boolean
}

export const prepareUploadJobImageParams = ({
  jobId,
  imageFile,
  fileSetId,
  isThumbnail,
}: UploadJobImageParams) => {
  const metadata = {
    section: 'job-images',
    'resource-kind': 'full',
    'file-set': fileSetId,
    'mime-type': imageFile.type,
  }
  const params = {
    filename: imageFile.name,
    job_id: jobId,
    metadata,
  }
  if (isThumbnail) {
    const thumbFileName = appendThumbToFileName(params.filename)
    params.metadata['resource-kind'] = 'thumb'
    params.filename = thumbFileName
  }

  return params
}
